<template>
  <footer class="c-footer">
    <div class="c-footer__container">
      <div class="c-footer__top">
        <ul class="c-footer-nav">
          <li class="c-footer-nav__item" v-for="item in footerNav" :key="item.link">
            <router-link :to="item.link" class="link__normal c-footer-nav__link">
              {{ $t(item.slug) }}
            </router-link>
          </li>
        </ul>
        <language-picker />
      </div>
      <div class="c-footer__bottom">
        <p class="copyright">
          © 1997–{{date.getFullYear()}} ПАО Сбербанк. Bсe права защищены. <a href="//sberbank.ru" target="_blank" class="link__text">www.sberbank.ru</a>
        </p>
      </div>
    </div>
  </footer>
</template>
<script>
import LanguagePicker from "@/components/language/LanguagePicker";
export default {
  data() {
    return {
      date: new Date(),
      footerNav: [
        { link: "/about", name: "", title: "О платформе", slug: "links.about" },
        {
          link: "/privacy",
          name: "",
          slug: "links.privacy"
        },
        { link: "/disclaimer", name: "", slug: "links.disclaimer" },
        {
          link: "/user_agreement",
          name: "",
          slug: "links.user_agreement"
        }
      ]
    };
  },
  components: {
    LanguagePicker
  }
};
</script>
